import { differenceInCalendarDays, differenceInWeeks, differenceInMonths, differenceInQuarters } from "date-fns";


class Utility {
  base64URLEncode = (str) => {
    return str
      .toString("base64")
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "");
  };

  parseJwt = (token) => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  getTimeStampAfter = (minutes) => {
    return new Date(new Date().getTime() + minutes * 60 * 1000);
  };

  getPercentageChange = (first, second) => {
    if (!first || first == 0) {
      return 100;
    } else {
      return ((second - first) / first) * 100;
    }
  }

  getDiffAsPerGranularityType = (date_granularity, startDate, endDate) => {
    let diff = 0;
    if (date_granularity == 'day') {
      diff = differenceInCalendarDays(startDate, endDate);
    } else if (date_granularity == 'week') {
      diff = differenceInWeeks(startDate, endDate);
    } else if (date_granularity == 'month') {
      diff = differenceInMonths(startDate, endDate);
    } else if (date_granularity == 'quarter') {
      diff = differenceInQuarters(startDate, endDate);
    }
    return diff;
  }

}
export default new Utility();
